d
<template>
  <div
    id="select-recipe-step-modal"
    tabindex="-1"
    aria-hidden="true"
    data-modal-backdrop="static"
    class="fixed top-0 left-0 right-0 z-50 hidden w-full px-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] md:h-full"
  >
    <div class="relative w-full h-full max-w-2xl md:h-auto">
      <!-- Modal content -->
      <div class="relative bg-white rounded-lg shadow ">
        <button
          type="button"
          class="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center  "
          @click="onClose"
        >
          <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
        <!-- Modal header -->
        <div class="px-6 py-4 border-b rounded-t ">
          <h3 class="text-base font-semibold text-gray-900 lg:text-xl ">
            {{ labels["TITLE_PRODUCE_STEP"][lg] }}
          </h3>
        </div>
        <!-- Modal body -->
        <div class="p-6 w-full max-h-fit relative">
          <div class="w-full relative flex flex-col">
            <div class="p-6 w-full top-0" :class="{ 'opacity-100 invisible ': loading, 'opacity-100 visible': !loading }">
              <div class="w-full flex flex-row items-center">
                <div class="w-full text-left justify-left flex flex-col">
                  <label for="name" class="w-full block mb-2 text-sm font-bold text-gray-900 "> name </label>
                  <input
                    id="select-recipe-step-modal-name"
                    v-model="name"
                    v-focus
                    type="text"
                    name="name"
                    class="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-primary-600 focus:border-primary-600 block p-2.5      "
                    placeholder=""
                  />
                </div>
              </div>
              <div class="w-full flex flex-row items-center mt-3">
                <div class="m w-full text-left justify-left flex flex-col">
                  <label for="name" class="w-full block mb-2 text-sm font-semibold text-gray-900 "> Description </label>

                  <textarea
                    id="select-recipe-step-modal-message"
                    v-model="description"
                    rows="4"
                    class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-sm border border-gray-300 focus:ring-blue-500 focus:border-blue-500      "
                    placeholder=""
                  />
                </div>
              </div>

              <div class="w-full flex flex-row items-center mt-3"></div>

              <div class="w-full mt-6 flex flex-row justify-between items-center mx-auto">
                <div class="max-w-[8.5rem] mx-auto text-left justify-left flex flex-col pr-2 max-w-[8.5rem] mx-auto">
                  <label for="name" class="w-full block mb-2 text-sm font-bold text-gray-900 "> Durée de la Tâche </label>

                  <div class="flex">
                    <input
                      type="time"
                      id="select-recipe-step-duration"
                      v-model="duration"
                      class="rounded-none rounded-s-lg bg-gray-50 border text-gray-900 leading-none focus:ring-blue-500 focus:border-blue-500 block flex-1 w-full text-sm border-gray-300 p-2.5      "
                    />
                  </div>
                </div>
                <div class="w-full text-left justify-left flex flex-col pl-2 max-w-[8.5rem] mx-auto">
                  <label for="name" class="w-full block mb-2 text-sm font-bold text-gray-900 "> Temps de Travail </label>

                  <div class="flex">
                    <input
                      type="time"
                      id="select-recipe-step-workload"
                      v-model="workload"
                      class="rounded-none rounded-s-lg bg-gray-50 border text-gray-900 leading-none focus:ring-blue-500 focus:border-blue-500 block flex-1 w-full text-sm border-gray-300 p-2.5      "
                    />
                  </div>
                </div>
              </div>
              <div class="w-full mt-6 flex justify-center">
                <div class="w-96 h-0.5 bg-gray-300" />
              </div>

              <div class="mt-4 w-full font-bold text-left mb-1">Contrôles à effectuer :</div>

              <treeselect v-model="controls" class="w-full bg-gray-50" :multiple="true" :options="options" :disable-branch-nodes="true" placeholder="" search-nested />
            </div>
          </div>

          <hr class="mb-3" />

          <div class="flex items-center justify-end">
            <button
              type="button"
              class="mr-3 py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200      "
              @click="onClose"
            >
              Annuler
            </button>
            <button
              type="button"
              class="inline-flex items-center text-white bg-gray-600 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center  "
              @click="onValidate"
            >
              Valider
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service from "@/services/FullService.vue";
import labels from "@/assets/lg/product-types.json";
import "@zanmato/vue3-treeselect/dist/vue3-treeselect.min.css";

import { mapGetters } from "vuex";
export default {
  name: "SelectRecipeStepModal",
  props: {
    input: Object,
    refresh: String,
  },
  emits: ["confirm", "close"],
  data() {
    return {
      lg: "FR",
loading: false,
      labels: labels,
      id: null,
      name: "",
      selectedTab: 0,
      description: "",
      duration: "00:00",
      workload: "00:00",
      controls: [],
      options: [],
    };
  },
  computed: {
    ...mapGetters({ user: "StateUser" }),
    isLoggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
  },
  watch: {
    refresh: function () {
      this.selectedTab = 0;
    },
    input: async function () {
      this.loading = true;
      await this.loadData();
      this.id = this.input?.id;
      this.name = this.input?.name;
      this.description = this.input?.description;
      this.duration = this.input?.duration;
      this.workload = this.input?.workload;
      this.controls = this.input?.controls;
      this.loading = false;
    },
  },
  async mounted() {
    if (this.user == undefined) {
      //this.$router.push("/login");
      window.location = "/login";

      await this.loadData();
      return;
    }
  },
  methods: {
    transformData(records) {
      let response = [];
      for (let i = 0; i < records.length; i++) {
        let record = records[i];
        let categoryIndex = response.findIndex(function (a) {
          return a.id == record.category?.code;
        });
        if (categoryIndex == -1) {
          categoryIndex = response.push({ label: record.category?.name, id: record?.category?.code, children: [] });
          categoryIndex--;
        }
        response[categoryIndex].children.push({ label: record.name, id: record._id });
      }
      return response;
    },

    async loadData() {
      let url = "data-sources/66bf46a4e83c6762c44e0467/records";
      let records = await service.getData(url, this.user?.token, { limit: 1000, offset: 0 });
      this.options = this.transformData(records.records);
    },

    onChangeTab(index) {
      this.selectedTab = index;
    },
    onClose() {
      this.$emit("close");
    },

    onValidate() {
      this.$emit("confirm", {
        id: this.id,
     
        index: this.input?.index,
        mode: this.input?.mode,
        attribute: this.input?.attribute,
        sub_attribute: this.input?.sub_attribute,
        parent_id: this.input?.parent_id,
        item_id: this.input?.item_id,
        name: this.name,
        description: this.description,
        duration: this.duration,
        workload: this.workload,
        controls: this.controls,
      });
    },
  },
  components: {},
};
</script>

<style>
.vue3-treeselect__input-container {
  border-width: 0px;
}

.vue3-treeselect__input-container:hover {
  border-width: 0px;
}

.vue3-treeselect__input-container:focus {
  border-width: 0px;
}

.vue3-treeselect__multi-value-label {
  font-size: 14px;
}
</style>
